/*-----scroll to top starts-----*/
$(document).ready(function() {
  var $backToTop = $('#back-top');
  // Hide initially
  $backToTop.hide();
  // Show / hide on scroll
  $(window).on('scroll', function() {
    if ($(window).scrollTop() > 220) {
      $backToTop.stop(true, true).fadeIn(400);
    } else {
      $backToTop.stop(true, true).fadeOut(400);
    }
  });
  // Smooth scroll to top on click
  $backToTop.on('click', function(e) {
    e.preventDefault();
    $('html, body').stop(true, true).animate({
      scrollTop: 0
    }, 800, 'swing');
  });
});
/*-----scroll to top ends-----*/

//Custom ATC for Collection page 
document.addEventListener('submit', function (e) {
  var form = e.target.closest('.collection-product-form form');
  if (!form) return;

  e.preventDefault();
  e.stopPropagation();

  var btn = form.querySelector('.add-to-cart');
  btn.classList.add('btn--loading');

  fetch(theme.routes.cartAdd, {
    method: 'POST',
    body: new FormData(form),
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
  .then(function (r) { return r.json(); })
  .then(function (data) {
    btn.classList.remove('btn--loading');
    if (data.status) return console.warn(data.description);

    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: { product: data, addToCartBtn: btn },
      bubbles: true
    }));
  });
}, true);